const tableHeadStyles = (theme) => ({
  headerRow: {
    '& .MuiTableCell-stickyHeader': {
      backgroundColor: '#e7e7e7',
    },
  },
  inactiveFilterIcon: {
    cursor: 'pointer !important',
    fontSize: '13px',
    color: '#adaaac',
    '&:hover': {
      backgroundColor: '#E7E7E7',
      color: '#000000',
    },
  },
  activeFilterIcon: {
    cursor: 'pointer !important',
    fontSize: '13px',
    color: '#000000',
    '&:hover': {
      backgroundColor: '#E7E7E7',
      color: '#000000',
    },
  },
  activeSortIcon: {
    opacity: 1,
    color: '#000000 !important',
  },
  // Half visible for inactive icons
  inactiveSortIcon: {
    opacity: 0.4,
  },
});

export default tableHeadStyles;
